import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, ShieldAlert } from 'lucide-react';
export function Hero() {
  return <section className="relative min-h-[80vh] flex items-center justify-center overflow-hidden bg-navy-950 text-white px-4 py-14" data-id="element-49">
      {/* Background subtle gradient/pattern */}
      <div className="absolute inset-0 opacity-20" data-id="element-50">
        <div className="absolute top-0 left-1/4 w-96 h-96 bg-gold-500 rounded-full mix-blend-multiply filter blur-[128px] animate-pulse" data-id="element-51" />
        <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-navy-400 rounded-full mix-blend-multiply filter blur-[128px]" data-id="element-52" />
      </div>

      <div className="relative z-10 max-w-4xl mx-auto text-center" data-id="element-53">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} data-id="element-54">
          <span className="inline-block py-1 px-3 rounded-full bg-gold-500/10 text-gold-300 text-sm font-medium tracking-wider uppercase mb-6 border border-gold-500/20" data-id="element-55">
            El Triángulo Roto
          </span>
        </motion.div>

        <motion.h1 className="text-3xl md:text-5xl lg:text-6xl font-serif font-bold leading-tight mb-8" initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} data-id="element-56">
          No es falta de fe. No es falta de dinero. No es falta de fuerza.
          <br className="hidden md:block" data-id="element-57" />
          <span className="block mt-4 text-gold-400 italic" data-id="element-58">
            Es una herida sin nombre que lleva años tomando decisiones por ti.
          </span>
        </motion.h1>

        <motion.p className="text-lg md:text-2xl text-navy-200 mb-10 max-w-3xl mx-auto font-light leading-relaxed" initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.4
      }} data-id="element-59">
          Para quien ora, trabaja duro... y aun así siente que algo invisible le
          bloquea el camino.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.5
      }} className="mb-12 flex justify-center" data-id="element-60">
          <div className="max-w-2xl bg-gold-500/5 border border-gold-500/20 rounded-2xl px-6 py-6 md:px-8 md:py-7 backdrop-blur-sm" data-id="element-61">
            <div className="flex items-center justify-center gap-2 mb-4" data-id="element-62">
              <ShieldAlert className="w-5 h-5 text-gold-400" data-id="element-63" />
              <span className="text-gold-300 font-bold uppercase tracking-[0.2em] text-sm" data-id="element-64">
                Aviso
              </span>
            </div>
            <p className="text-lg md:text-xl text-navy-100 leading-relaxed text-center" data-id="element-65">
              Solo para personas serias que están listas para sanar sus heridas
              con{' '}
              <span className="text-white font-semibold" data-id="element-66">
                Dios, el Dinero y la Disciplina
              </span>
              .
            </p>
            <p className="font-serif italic text-gold-200 text-lg md:text-xl text-center mt-2" data-id="element-67">
              De una vez por todas.
            </p>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.7
      }} data-id="element-68">
          {/* Pricing teaser */}
          <div className="mb-6 inline-flex flex-col items-center gap-1" data-id="element-69">
            <p className="text-navy-300 text-sm" data-id="element-70">
              <span className="mr-1" data-id="element-71">💰</span>
              Valor real:{' '}
              <span className="line-through text-navy-400" data-id="element-72">$397</span>
              <span className="mx-2 text-white/30" data-id="element-73">·</span>
              <span className="text-gold-300 font-semibold" data-id="element-74">Hoy: $97 USD</span>
            </p>
            <p className="text-xs text-navy-400 italic" data-id="element-75">
              Precio de lanzamiento — solo primeros{' '}
              <span className="text-gold-300 font-bold not-italic" data-id="element-76">
                10 clientes
              </span>
            </p>
          </div>

          <a href="#cta-final" className="inline-flex items-center justify-center gap-2 bg-gold-500 hover:bg-gold-400 text-navy-950 px-8 py-4 rounded-full text-lg font-semibold transition-all duration-300 transform hover:scale-105 shadow-[0_0_40px_-10px_rgba(211,154,34,0.5)]" data-id="element-77">
            QUIERO RESERVAR MI ESPACIO
            <ArrowRight className="w-5 h-5" data-id="element-78" />
          </a>
        </motion.div>
      </div>
    </section>;
}